import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ButtonWrap } from './CoupleItemStyle';
import Button from '@components/dataEntry/button/Button';
import { useNavigate } from 'react-router-dom';
import { deleteCouple } from '@store/firebase/couple/delete-couple';

const Div = styled.div``;

type Props = {
  data: any;
  collectionPath?: string;
};
function CoupleEditBtnSec({ data, collectionPath }: Props) {
  const history = useNavigate();

  const handleDeleteCouple = useCallback(
    async (e) => {
      e.preventDefault();
      if (!collectionPath || !data) return;
      if (confirm('포스팅을 삭제하시겠습니까?')) {
        await deleteCouple({ docId: data.id!, collectionPath });
      } else {
        return;
      }
    },
    [data, collectionPath],
  );

  return (
    <ButtonWrap>
      <Button shape="stroke" color="warning" onClick={handleDeleteCouple}>
        삭제
      </Button>
      <Button
        onClick={(e) => {
          e.preventDefault();
          history(`/${collectionPath}-edit/${data.id}`);
        }}
      >
        수정
      </Button>
    </ButtonWrap>
  );
}

export default CoupleEditBtnSec;
